'use client';

import { FC } from 'react';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';

import { BlockValuePromptType } from '../../models/Content';
import { getBlockId } from '../../utils/content';
import { BlockHeader } from '../common/BlockHeader';
import { ValuePromptBlockContainer, ValuePromptBlockGrid, ValuePromptBlockSection } from './BlockValuePrompt.styles';
import { transformValuePrompt } from './transformers';
import { ValuePrompt } from './ValuePrompt';

type Props = {
    contentItem: BlockValuePromptType;
};

export const BlockValuePrompt: FC<Props> = ({ contentItem: initialContentItem }) => {
    const contentItem = useContentfulLiveUpdates(initialContentItem);
    const { blockTitle, blockCta, values, colorVariant, variant } = transformValuePrompt(contentItem);

    return (
        <ValuePromptBlockSection
            $colorVariant={colorVariant}
            $variant={variant}
            data-section="Value Prompt Block"
            data-section-name={blockTitle}
            data-section-display-option={variant}
            data-section-color-option={colorVariant}
            id={getBlockId(contentItem)}
        >
            <ValuePromptBlockContainer $colorVariant={colorVariant} $variant={variant} noGap={true}>
                {blockTitle && variant !== 'compact' && <BlockHeader title={blockTitle} cta={blockCta} />}
                <ValuePromptBlockGrid>
                    {values.map((value, index) => (
                        <li key={index}>
                            <ValuePrompt {...value} />
                        </li>
                    ))}
                </ValuePromptBlockGrid>
            </ValuePromptBlockContainer>
        </ValuePromptBlockSection>
    );
};
